import { useEmployeeAvailabilityApi } from 'infrastructure/api';
import { INTERRUPTIONS_RESOURCE_URL, DEFAULT_INTERRUPTIONS_SEARCH_REQUEST } from './constants';
import {
  InterruptionCreateRequest,
  InterruptionDto,
  InterruptionEmployeeResponseStatus,
  InterruptionSearchResponse,
  InterruptionViewStatus,
  SendInterruptionTeamsResponseMessageResponse,
} from './types';
import { LoadingParams } from 'framework/list';

const useInterruptionService = () => {
  const { sendPostRequest, sendDeleteRequest, sendPutRequest } = useEmployeeAvailabilityApi();

  const searchInterruptions = async (
    request: LoadingParams = DEFAULT_INTERRUPTIONS_SEARCH_REQUEST,
  ): Promise<InterruptionSearchResponse> => {
    const response = await sendPostRequest(`${INTERRUPTIONS_RESOURCE_URL}/search`, request);
    return response.json();
  };

  const createInterruption = async (request: InterruptionCreateRequest): Promise<InterruptionDto> => {
    const response = await sendPostRequest(INTERRUPTIONS_RESOURCE_URL, request);
    return response.json();
  };

  const cancelInterruption = async (id: string) => {
    return await sendDeleteRequest(`${INTERRUPTIONS_RESOURCE_URL}/${id}`);
  };

  const updateInterruptionStatus = async (id: string, employeeResponseStatus: InterruptionEmployeeResponseStatus) => {
    const response = await sendPutRequest(`${INTERRUPTIONS_RESOURCE_URL}/${id}/status`, {
      employeeResponseStatus,
    });
    return response.json();
  };

  const updateInterruptionsViewStatus = async (ids: string[], viewStatus: InterruptionViewStatus) => {
    const response = await sendPutRequest(`${INTERRUPTIONS_RESOURCE_URL}/view-status`, {
      ids,
      viewStatus,
    });
    return response.json();
  };

  const sendInterruptionTeamsMessage = async (id: string): Promise<SendInterruptionTeamsResponseMessageResponse> => {
    const response = await sendPostRequest(`${INTERRUPTIONS_RESOURCE_URL}/${id}/teams-response-message`, {});
    return response.json();
  };

  return {
    cancelInterruption,
    createInterruption,
    searchInterruptions,
    updateInterruptionStatus,
    updateInterruptionsViewStatus,
    sendInterruptionTeamsMessage,
  };
};

export default useInterruptionService;
